import { render } from "./AkadSafety.vue?vue&type=template&id=2b97c1f4&scoped=true"
import script from "./AkadSafety.vue?vue&type=script&lang=js"
export * from "./AkadSafety.vue?vue&type=script&lang=js"

import "./AkadSafety.vue?vue&type=style&index=0&id=2b97c1f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b97c1f4"]])

export default __exports__